import { Component, Input, OnInit } from '@angular/core';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $;
@Component({
  selector: 'app-sw-markimg-box',
  templateUrl: './sw-markimg-box.component.html',
  styleUrls: ['./sw-markimg-box.component.css']
})
export class SwMarkimgBoxComponent implements OnInit {

  // 快捷操作：新增关系、编辑关系
  @Input() state:string
  comentParams = {
    upOrAdd: 'markImg',      // 图像标记
    imgData: {}          // 进行图像标记时需传递的参数
  }

  constructor(
    private jwt: SwJwtService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(){
    if(this.state == 'markImg'){
      $('.markImgBox').css('right','0');
      this.comentParams = JSON.parse(this.jwt.getToken('imgInfo'));
    }else{
      $('.markImgBox').css('right','-660px');
    }
  }

  // 执行保存、最小化、关闭操作，需关闭右侧弹出框
  componentStateChange(event){
    $('.markImgBox').css('right','-660px');
  }
}
